import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import * as React from 'react';
import { useQueryClient } from 'react-query';
import useExportSchemaBulkWidgets
  from '../../../../../api/hooks/useExportSchemeBulkWidgets';
import { useLocation } from 'react-router';
import {
  iconStyle,
  MuiCommonButton, MuiUploadDownloadTypography
} from './styles/uploadDownloadJson';
import { useTranslation } from '../../../../providers/TranslationProvider';
import { GLOBAL } from '../../../../../utils/constants';
import { useTheme } from '../../../../providers/CustomThemeProvider';

const DownloadJSON = ({id, values, layers, tabs, widgets, setErrors}) => {
  const location = useLocation();
  const queryClient = useQueryClient();
  const { mutateAsync } = useExportSchemaBulkWidgets(setErrors);
  const { t } = useTranslation();
  const { theme } = useTheme();

  const handleExport = () => {
    try {
      mutateAsync({
        userId: id,
        scheme: {
          ...values,
          id: location.pathname.split('/')[4] === 'create' ? '' : location.pathname.split('/')[4],
          layers,
          widgets,
          tabs,
          type: 'descriptive-spatial-analysis',
        },
      }).then(async () => {
        const data = queryClient.getQueryData('export_scheme_bulk_widgets');
        const json = JSON.stringify(data);
        const blob = new Blob([json], { type: 'application/json' });
        const href = await URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = `${data.name} schema.json`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (e) {
      setErrors('testing');
    }
  };

  return  (
    <MuiCommonButton
      startIcon={<CloudDownloadIcon sx={{color: theme.palette.primary.main}} />}
      component='span'
      variant='outlined'
      onClick={handleExport}
    >
      <MuiUploadDownloadTypography>
        {t('download_json')}
      </MuiUploadDownloadTypography>
    </MuiCommonButton>
  );
}

export default DownloadJSON
